<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>
                    <router-link class="my-3 d-inline-block" :to="{ name: 'event', params: { id: event.id }}">
                        Back to All Invites
                    </router-link>

                    <h2>
                        Edit the invitation for {{ invite.first_name }} {{ invite.last_name }} to {{ event.name }}
                    </h2>

                    <b-form @submit.prevent="onSubmit">
                        <b-form-group>
                            <custom-select
                                :options="status_options"
                                :defaultvalue="form.status"
                                :heading="'Select a status'"
                                @option-selected="(option) => form.status = option.value">
                            </custom-select>

                            <b-form-input
                                class="tb-form-field"
                                placeholder="First Name"
                                type="text"
                                v-model="form.first_name"
                                required>
                            </b-form-input>

                            <b-form-input
                                class="tb-form-field"
                                placeholder="Last Name"
                                type="text"
                                v-model="form.last_name"
                                required>
                            </b-form-input>

                            <b-form-input
                                class="tb-form-field"
                                placeholder="Phone"
                                type="text"
                                v-model="form.phone">
                            </b-form-input>

                            <b-form-input
                                class="tb-form-field"
                                placeholder="Email"
                                type="text"
                                v-model="form.email"
                                required>
                            </b-form-input>

                            <div v-for="custom_field in form.custom_fields" :key="custom_field.name">
                                <label>
                                    {{custom_field_labels[custom_field.name]}}
                                </label>

                                <b-form-input
                                        type="text"
                                        v-model="custom_field.value">
                                </b-form-input>
                            </div>

                            <p>Questions</p>
                            <answerable-question-list
                                    class="answerable-question-list--white"
                                    :questions="invite.event.questions"
                                    :answers="invite.answers"
                                    @changed="(index, answer) => answerChanged(index, answer)">

                            </answerable-question-list>

                            <b-button type="submit" class="tb-button tb-button--blue tb-button--small">
                                Edit
                            </b-button>
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    import inviteRepository from "@/repository/invites";
    import answerRepository from "@/repository/answers";
    import AnswerableQuestionList from '@/components/AnswerableQuestionList.vue';
    import CustomSelect from "@/components/CustomSelect";

    //required for axios.all, maybe we can wrap thism in a repo method?
    import axios from "axios";

    export default {
        components: {
            AnswerableQuestionList,
            CustomSelect
        },
        props: ['id', 'invite_id'],

        data() {
            return {
                event: null,
                invite: null,
                status_options: [
                    {
                        'value': 'UNSENT',
                        'text': 'Unsent'
                    },
                    {
                        'value': 'SENT',
                        'text': 'Sent'
                    },
                    {
                        'value': 'VIEWED',
                        'text': 'Viewed'
                    },
                    {
                        'value': 'ACCEPTED',
                        'text': 'Accepted'
                    },
                    {
                        'value': 'REJECTED',
                        'text': 'Rejected'
                    },
                    // 'UNSENT',
                    // 'SENT',
                    // 'VIEWED',
                    // 'ACCEPTED',
                    // 'REJECTED'
                ],
                form:{},
                custom_field_labels:{},
                answers:[],
                loaded: false,
                errors: {}
            }
        },

        mounted() {
            inviteRepository.getById(this.invite_id,
                {
                    include: ['event', 'event.client', 'event.questions', 'answers']
                })
                .then(response => {
                    this.invite = response.data;
                    this.event = response.data.event;
                    this.loaded = true;
                    this.answers = this.invite.answers;

                    this.form = {...this.invite};
                    //make sure custom fields are valid, for example, if the clients allowed fields have been changed after invite created
                    //todo bad nameing - client.custom_invite_fields & invite.custom_fields is going to cause typo bugs
                    let fields = [];
                    //start with the clients custom fields, not those already set on invite, as may have changed
                    this.event.client.custom_invite_fields.forEach(f=>{
                        let field = {
                            name: f.name,
                            value:''
                        };
                        //push label from client into map for lookup later
                        this.custom_field_labels[f.name] = f.label;

                        let invite_custom_field = this.invite.custom_fields.find(e=>e.name == f.name);
                        if(invite_custom_field && invite_custom_field.value){
                            field.value = invite_custom_field.value;
                        }
                        fields.push(field);
                    });
                    //overwrite form.custom_fields
                    this.form.custom_fields = fields;


                });
        },

        computed: {},

        methods: {
            onSubmit() {
                inviteRepository.update(this.form)
                    .then(response => {
                        //save the answers
                        let answer_responses = [];
                        this.answers.forEach(a=>{
                            console.log(a);
                            //ignore empty answers that do not already exist
                            // surely we should not return here, right?
                            // if(a.answer.text =='' && !a.answer.hasOwnProperty('id')) return;
                            //if it has an id and text, it exists and needs to be updated
                            if(a.text !=='' && a.hasOwnProperty('id')){
                                answer_responses.push(answerRepository.update(a));
                            }
                            //if is has an id and empty text, delete it
                            else if(a.text =='' && a.hasOwnProperty('id')){
                                answer_responses.push(answerRepository.destroy(a.id));
                            }
                            //else its a new answer, give it the required fields
                            else{

                                //todo this could probably be done in AnswerableQuestionList.vue if it had the invite id available?
                                let payload = {
                                    question_id: a.question.id,
                                    invite_id: this.invite.id,
                                    text: a.answer.text
                                }
                                answer_responses.push(answerRepository.store(payload));
                            }
                        })
                        return axios.all(answer_responses);
                    })
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Invite edited',
                            text: 'Invite successfully edited.'
                        });

                    })

                    .catch(error => {
                        console.log(error);
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: errors,
                                duration: 10000,
                                width: '500px'
                            });
                        }
                    });
            },
            toTitleCase(str){
                return str.replace(/_/,' ').replace(/\b\S/g, t => t.toUpperCase());
            },

            answerChanged(index, answer) {
                console.log(index, answer);
                this.answers[index].text = answer;
            },
        }
    }
</script>

<style scoped lang="scss">
    input, select {
        margin-bottom: 20px!important;
    }

    select {
        margin-bottom: 10px;
    }
</style>